import AbstractPageBaseController from '../../../core/abstracts/controllers/page-controller';

export default class ContactsChangelogPageController extends AbstractPageBaseController {

}



// WEBPACK FOOTER //
// ./src/app/modules/contacts/controllers/pages/changelog.js